<template>
  <div id="guide" @scroll="getHeight">
    <div class="title">
      <img class="title1" src="@/assets/img/taiko/guide/header_1.png" alt="" />
      <img class="introduction" src="@/assets/img/taiko/songs/song_title.png" alt="" />
    </div>
    <div class="content">
      <div class="content_handle pdt10">
        <div class="handle_row">
          <img class="bounce-in-left" :class="{ button_gray: type !== '流行音乐' }" src="@/assets/img/taiko/songs/type(3).png"
            @click="swtichToType('流行音乐')" alt="" />
          <img class="bounce-in-right" :class="{ button_gray: type !== '儿童音乐' }"
            src="@/assets/img/taiko/songs/type(7).png" @click="swtichToType('儿童音乐')" />
        </div>
      </div>
      <div class="content_handle">
        <div class="handle_row">
          <img class="bounce-in-left" :class="{ button_gray: type !== '动漫音乐' }" src="@/assets/img/taiko/songs/type(2).png"
            @click="swtichToType('动漫音乐')" alt="" />
          <img class="bounce-in-right" :class="{ button_gray: type !== '博歌乐音乐' }"
            src="@/assets/img/taiko/songs/type(6).png" @click="swtichToType('博歌乐音乐')" alt="" />
        </div>
      </div>
      <div class="content_handle">
        <div class="handle_row">
          <img class="bounce-in-left" :class="{ button_gray: type !== '游戏音乐' }" src="@/assets/img/taiko/songs/type(1).png"
            @click="swtichToType('游戏音乐')" alt="" />

          <img class="bounce-in-right" :class="{ button_gray: type !== '综合音乐' }"
            src="@/assets/img/taiko/songs/type(5).png" @click="swtichToType('综合音乐')" alt="" />
        </div>
      </div>
      <div class="content_handle">
        <div class="handle_row">
          <img class="bounce-in-left" :class="{ button_gray: type !== '古典音乐' }" src="@/assets/img/taiko/songs/type.png"
            @click="swtichToType('古典音乐')" alt="" />
          <img class="bounce-in-right" :class="{ button_gray: type !== '南梦宫原创音乐' }"
            src="@/assets/img/taiko/songs/type(4).png" @click="swtichToType('南梦宫原创音乐')" alt="" />
        </div>
      </div>
      <div class="song_title">
        <div class="title">
          <img class="bg" src="@/assets/img/taiko/songs/title.png" width="200" alt="" />
          <span :style="{ 'color': songTypeColorEnum[type].color1 }">{{ songTypeColorEnum[type].title||type }}</span>
        </div>
      </div>

      <div class="song_tag">
        <div class="tag yellow">
          MEDAL
        </div>
        <!-- <div class="tag orange">
          MEDAL(魔王里)
        </div> -->
        <!-- <div class="tag blue">
          AI BATTLE
        </div>
        <div class="tag green">
          CAMPAIGN
        </div>
        <div class="tag pink">
          CODE
        </div>
        <div class="tag lightblue">
          SECRET
        </div> -->
      </div>
      <div class="tag_intro" @click="openTagsIntro">
        各图标的说明在这里
      </div>
      <div class="song_mark" v-if="songTypeColorEnum[type].mark">{{ songTypeColorEnum[type].mark }}</div>
      <div class="songs_main bounce-in-bottom">
        <div class="block">
          <div class="songs_main_title" :style="{ 'background-color': songTypeColorEnum[type].color3 }"
            @click="openFliter">
            <div class="songs_sort">
              <img src="@/assets/img/taiko/songs/updown.png" />
              <span>排序</span>
              <!-- <span>↑↓排序</span> -->
            </div>
            <div class="songs_name" :style="{ 'color': songTypeColorEnum[type].color2 }">曲目</div>
            <div class="songs_score">
              <span class="text_1">亲子互动</span>
              <div class="songs_level">
                <div class="text_2" :style="{ 'color': songTypeColorEnum[type].color2 }">难易度</div>
                <div class="songs_img">
                  <div class="songs_icon">
                    <img src="@/assets/img/taiko/songs/10005.png" alt="" />
                  </div>
                  <div class="songs_icon">
                    <img src="@/assets/img/taiko/songs/10001.png" alt="" />
                  </div>
                  <div class="songs_icon">
                    <img src="@/assets/img/taiko/songs/10002.png" alt="" />
                  </div>
                  <div class="songs_icon">
                    <img src="@/assets/img/taiko/songs/10003.png" alt="" />
                  </div>
                  <div class="songs_icon">
                    <img src="@/assets/img/taiko/songs/10004.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="songs_main_content"
            :style="{ 'border-left': `0.08rem solid ${songTypeColorEnum[type].color3}`, 'border-right': `0.08rem solid ${songTypeColorEnum[type].color3}`, 'border-bottom': `0.08rem solid ${songTypeColorEnum[type].color3}` }">
            <div class="song_item" v-for="(item, index) in songs" :key='index'
              :style="{ 'background-color': index % 2 === 0 ? songTypeColorEnum[type].color4 : songTypeColorEnum[type].color5 }">
              <div class="song_block_1">
                <div class="song_content">
                  <img class="icon" src="@/assets/img/taiko/songs/10006.png" />
                  <div class="song_info">
                    <!-- <div class="main_text" :style="{ 'color': songTypeColorEnum[type].color2 }" v-if="item.song_name_jp">
                      {{ item.song_name_jp }}</div> -->
                    <div class="main_text" :style="{ 'color': songTypeColorEnum[type].color2 }">{{ item.song_name }}</div>
                    <div class="singer">{{ item.subtitle }}</div>
                  </div>
                </div>
                <div class="new">
                  <!-- <img v-if="item.news" src="@/assets/img/taiko/songs/new.png" alt=""> -->
                  <div class="song_tag">
                    <div v-if="item.tag === 'MEDAL'" class="tag yellow">
                      MEDAL
                    </div>
                    <div v-if="item.tag === 'MEDAL(魔王里)'" class="tag orange">
                      MEDAL(魔王里)
                    </div>
                    <div v-if="item.tag === 'AI BATTLE'" class="tag blue">
                      AI BATTLE
                    </div>
                    <div v-if="item.tag === 'CAMPAIGN'" class="tag green">
                      CAMPAIGN
                    </div>
                    <div v-if="item.tag === 'CODE'" class="tag pink">
                      CODE
                    </div>
                    <div v-if="item.tag === 'SECRET'" class="tag lightblue">
                      SECRET
                    </div>
                  </div>
                </div>
              </div>
              <div class="song_block_2">
                <span class="social"><label v-if="item.family"></label></span>
                <span class="scope">{{ item.level_1 }}</span>
                <span class="scope">{{ item.level_2 }}</span>
                <span class="scope">{{ item.level_3 }}</span>
                <span class="scope">{{ item.level_4 }}</span>
                <span class="scope">{{ item.level_5 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="stars"></div>
        <img class="back" @click="scrollToTop" src="@/assets/img/taiko/guide/footer_back.png" alt="" />
        <div class="bg">
          <img src="@/assets/img/taiko/guide/footer_bg.png" alt="" />
          <img src="@/assets/img/taiko/guide/footer_logo.png" alt="" />
        </div>
      </div>
    </div>
    <SongFilter :showModal="showModal"  @filterData="filterData" @close="showModal = false"></SongFilter>
    <div class="modal" v-if="showIntroModal" @click.self="showIntroModal = false">
      <div class="modal-container">
        <div class="modal-content">
          <slot>
            <div class="tags_modal">
              <div class="tag_close" @click="showIntroModal = false">×</div>
              <div class="tag_item">
                <div class="tag yellow">
                  MEDAL
                </div>
                <div class="tag_text">
                  <span class="text_blue">咚币商店</span>
                  <span>里交换后可以体验的歌曲。</span>
                </div>
              </div>
              <!-- <div class="tag_item">
                <div class="tag orange">
                  MEDAL(魔王里)
                </div>
                <div class="tag_text">
                  <span>仅限于难度为「魔王里」在</span>
                  <span class="text_blue">咚币商店</span>
                  <span>里交换后可以体验的歌曲。</span>
                </div>
              </div> -->
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import songs from '@/assets/data/songs'
import { songTypeColorEnum } from '@/assets/enum/constant'
import SongFilter from './Filter'
export default {
  name: "guide",
  data() {
    return {
      songTypeColorEnum,
      scrollTop: 0,
      type: '流行音乐',
      allSongs: songs,
      songs,
      showModal: false,
      showIntroModal: false,
      keepFilterData: {
        level: 0,
        sortUp: -1,
      }
    };
  },
  components: {
    SongFilter
  },
  mounted() {
    //监听滚动的Y轴并log返回Y轴的值
    const element = document.getElementById("guide");
    element.addEventListener("scroll", this.getHeight);
    this.swtichToType('流行音乐')
  },
  beforeDestroy() {
    const element = document.getElementById("guide");
    element.removeEventListener("scroll", this.getHeight);
  },
  methods: {
    getHeight() {
      const element = document.getElementById("guide");
      let scrollTop = element.scrollTop;
      this.scrollTop = scrollTop;
      // console.log(scrollTop);
    },
    swtichToType(data) {
      // console.log(data);
      this.type = data;
      let result = this.allSongs.filter(item => item.type === data);
      // console.log(result);
      this.songs = result;
      if (this.type === '') {
        this.songs = this.allSongs
      }
      this.filterData(this.keepFilterData)
    },
    openFliter() {
      this.showModal = true;
    },
    openTagsIntro() {
      this.showIntroModal = true;
    },
    filterData(data) {
      // console.log(data)
      this.keepFilterData = data;
      //data.sortUp为true则根据data.level来进行this.songs[`level_${data.level}`]进行升序，否则降序
      if (data.level === 0) {
        let result = this.allSongs.filter(item => item.type === this.type);
        // console.log(result);
        this.songs = result;
      } else if (data.level === 10) {
        //判断this.allSongs中的family是否等于o，如果不存在则把他们排在最后，再开始排序
        let result = this.songs.filter(item => item.family === '○')
        let result2 = this.songs.filter(item => item.family !== '○')
        this.songs = result.concat(result2)
      }
      else if (data.level === 5) {
        //判断this.allSongs中的level_5是否存在，如果不存在则把他们排在最后，再开始排序
        let result = this.songs.filter(item => item[`level_${data.level}`] !== undefined)
        if (data.sortUp == 1) {
          result = result.sort((a, b) => a[`level_${data.level}`] - b[`level_${data.level}`])
        } else {
          result = result.sort((a, b) => b[`level_${data.level}`] - a[`level_${data.level}`])
        }
        let result2 = this.songs.filter(item => item[`level_${data.level}`] == undefined)

        this.songs = result.concat(result2)
      }
      else {
        this.sortSong(data)
      }
    },
    sortSong(data) {
      if (data.sortUp == 1) {
        //如果this.songs[`level_${data.level}`]不存在，则把他们排在最后
        let result = this.songs.sort((a, b) => a[`level_${data.level}`] - b[`level_${data.level}`])
        this.songs = result
      } else {
        let result = this.songs.sort((a, b) => b[`level_${data.level}`] - a[`level_${data.level}`])
        this.songs = result
      }
    },
    scrollToSomeY(type, point) {
      this.type = type;
      // console.log('someY',point)
      let timer = setInterval(() => {
        const element = document.getElementById("guide");
        let ispeed = Math.floor((point - element.scrollTop) / 30);
        element.scrollBy(this.scrollTop, this.scrollTop + ispeed);
        if (element.scrollTop >= point) {
          element.scrollTop = point;
          clearInterval(timer);
        }
      }, 22);
    },
    scrollToTop() {
      // console.log('back')
      let timer = setInterval(() => {
        const element = document.getElementById("guide");
        let ispeed = Math.floor(this.scrollTop / 6);
        element.scrollTop = this.scrollTop - ispeed;
        if (element.scrollTop <= 6) {
          // element.ssongs_scorecrollTop === 0;
          clearInterval(timer);
        }
      }, 22);
    },
  },
};
</script>

<style lang='scss' scoped>
@import "assets/scss/index.scss";
@import "./index.scss";
</style>